import { combineReducers } from '@reduxjs/toolkit';

import CMSSlice from './CMSSlice';
import langSlice from './langSlice';
import settingsSlice from './settingsSlice';
import countrySlice from './countrySlice';
import FTASlice from './FTASlice';
import FTATypeSlice from './FTATypeSlice';
import authSlice from './authSlice';
import companySlice from './companySlice';

const rootReducer = combineReducers({
  auth: authSlice,
  cms: CMSSlice,
  lang: langSlice,
  settings: settingsSlice,
  country: countrySlice,
  fta: FTASlice,
  ftaType: FTATypeSlice,
  company: companySlice,
});

export default rootReducer;
